
export const transform = ({
                              id,
                              name,
                              match_score,
}) => (
  {
    id: id,
    name: name,
    match_score: match_score,
  }
);
